// extracted by mini-css-extract-plugin
export var expandedRowWrapper = "_4v-6";
export var headerCell = "_4v-2";
export var rowWrapper = "_4v-4";
export var stickyAggregationCell = "_4v-a";
export var stickyAggregationRow = "_4v-7";
export var stickyColumnCell = "_4v-9";
export var stickyColumnHeaderCell = "_4v-8";
export var table = "_4v-1";
export var virtualRowWrapper = "_4v-5";
export var virtualTableContainer = "_4v-0";
export var white = "_4v-3";